import { cn } from "../../lib/utils"

/**
 * Skeleton — a shimmering placeholder block. The shimmer (`.eq-shimmer` in
 * globals.css) is a slow gold-tinted sweep on the navy-tint base; add
 * `eq-shimmer--dark` on a navy surface. Disabled under reduced motion.
 */
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("eq-shimmer rounded-md", className)}
      {...props}
    />
  )
}

export { Skeleton }
